import React from "react";
import { Stack, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";

export interface TextOnImageProps {
  image?: string;
  title?: string;
}
const useStyles = makeStyles((theme: any) => ({
  headingMain: {
    color: theme.palette.common.white,
    fontSize: 60,
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 700,
    textAlign: "center",
    position: "relative",
  },

  header: {
    backgroundImage: (props: any) => (props.image ? `url(${props.image})` : ""),
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "625px",
  },
  overlay: {
    width: "100%",
    height: "100%",
    background: `#4444445e`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  styledBorder: {
    border: "1px solid #FFFFFF",
    height: "85%",
    width: "90%",
    display: "flex",
    alignItems: "center",
    placeContent: "center",
  },
}));
const TextOnImage = ({ image, title }: TextOnImageProps) => {
  const classes = useStyles({ image });
  return (
    <Stack>
      <Box className={classes.header}>
        <Box className={classes.overlay}>
          <Box className={classes.styledBorder}>
            <Box className={classes.headingMain}>{title}</Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
};
export default TextOnImage;
